angular.module('GlobalHelpersModule').filter "prettyDateTime", ->
  (date) ->
    if date? and date.length > 0 then moment(date).format('MMM D, YYYY h:mm a') else ""